import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface CarbonProjectState {
    data: [] | null | any;
    totalRecords: number | null;
    totalPages: number | null;
}

const initialState: CarbonProjectState = {
    data: null,
    totalRecords: null,
    totalPages: null,
};

export const carbonProjectSlice = createSlice({
    name: 'carbonProject',
    initialState,
    reducers: {
        setCarbonProject: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
        },
        reset: (state) => {
            Object.assign(state, initialState);
        },
    },
});

export const { setCarbonProject, reset } = carbonProjectSlice.actions;
export const getAllCarbonProjectsDetails = (state: RootState) => state.carbonProject.data;
export const getCarbonProjectsTotalRecords = (state: RootState) => state.carbonProject.totalRecords;
export default carbonProjectSlice.reducer;
